// import external dependencies
import 'jquery';

// Import everything from autoload


// import local dependencies
import './routes/common';
import './routes/ajax';
import './routes/map';
import './routes/animation';

import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';
// import Icons from './icons/uikit-icons-coteacote.min.js';

UIkit.use(Icons);

function toggleBurger(action){
  var class_active = 'is-active';
  if(action == 'hide'){
    $(".vy_mobile_menu").removeClass(class_active);
  }else if(action == 'show'){
    $(".vy_mobile_menu").addClass(class_active);
  }else{
    $(".vy_mobile_menu").toggleClass(class_active);
  }
}

$(function () {
  UIkit.util.on('#offcanvas_mobile', 'show', function () {
    toggleBurger('show');
  });
  UIkit.util.on('#offcanvas_mobile', 'hide', function () {
    toggleBurger('hide');
  });
  UIkit.util.on('#dropdown_mobile', 'show', function () {
    if($('#dropdown_mobile').hasClass('uk-active')){
      toggleBurger('show');
    }
  });
  UIkit.util.on('#dropdown_mobile', 'hide', function () {
    if(!$('#dropdown_mobile').hasClass('uk-active')){
      toggleBurger('hide');
    }
  });
  UIkit.util.on('#modal-mobile', 'show', function () {
    toggleBurger('show');
  });
  UIkit.util.on('#modal-mobile', 'hide', function () {
    toggleBurger('hide');
  });
  UIkit.util.on('#offcanvas_cart', 'show', function () {
    toggleBurger('show');
  });
  UIkit.util.on('#offcanvas_cart', 'hide', function () {
    toggleBurger('hide');
  });
});
